import React, { Component } from 'react'
import { connect } from 'react-redux'
import Icon from '../../elements/icon'
import { CarRentalIcons } from '../../elements/icons'

// Utils
import { translation } from '../../../utils/helpers'
import { renderFullDate } from '../../../utils/time'

// contants
import { CarRentalSystemTypes } from '../../../constants'

import './carrentalassignmentlist.scss'

class CarRentalAssignmentList extends Component {

  renderGroup (group, i) {
    let groupName = ''
    if (group.CarRentalId > 0) {
      groupName = translation(14859) + ' ' + group.CarNumber + ' - ' + group.Identity
    } else {
      groupName = group.Identity
    }

    const getDate = (dateTime) => { return dateTime.split(' - ')[0] }
    const getTime = (dateTime) => { return dateTime.split(' - ')[1] }

    const renderPeriod = (p, i) => {
      let start = renderFullDate(p.Start)
      let end = renderFullDate(p.End)
      return (
        <div key={'period_' + i} className='period'>
          <div className='period__start'>
            <div>{translation(16771)}</div>
            <div className='period__date'>
              <span>{getDate(start)}</span>
              <span>{getTime(start)}</span>
            </div>
          </div>
          <div className='period__end'>
            <div>{translation(16772)}</div>
            <div className='period__date'>
              <span>{getDate(end)}</span>
              <span>{getTime(end)}</span>
            </div>
          </div>
        </div>
      )
    }

    const renderContractStatus = () => {
      if (group.CarRentalSystem === CarRentalSystemTypes.RENTLOG) return
      if (group.ContractStatus === 1) {
        // Not created
        return (
          <div className='assignment-contract'>
            <Icon icon={CarRentalIcons.Warning} />
            <div>{translation(16814)}</div>
          </div>
        )
      } else if (group.ContractStatus === 2) {
        // Created
        return (
          <div className='assignment-contract'>
            <Icon icon={CarRentalIcons.OK} />
            <div>{translation(16815)}</div>
          </div>
        )
      }
      return null
    }

    return (
      <div key={'assignment_' + i} className='assignment'>
        <div className='rental-title'>{groupName}</div>
        <div className='assignment-periods'>
          {group.Periods.map(renderPeriod)}
        </div>
        {group.CarRentalSystem === CarRentalSystemTypes.RENTLOG && <br />}
        {renderContractStatus()}
      </div>
    )
  }

  render () {
    // Data comes in as list of periods. Group items by car / car alternative
    const groupBy = (item) => { return item.CarRentalId + '_' + item.CarRentalAltId }
    let groups = {}
    this.props.items.map(i => {
      let groupKey = groupBy(i)
      if (groups[groupKey] === undefined) {
        // new group
        groups[groupKey] = {
          CarRentalId: i.CarRentalId,
          CarRentalAltId: i.CarRentalAltId,
          CarNumber: i.CarNumber,
          Identity: i.Identity,
          ContractStatus: i.ContractStatus,
          Periods: [{Start: i.Start, End: i.End}],
          CarRentalSystem: this.props.auth.carRentalSystem
        }
      } else {
        // Add period to existing group
        groups[groupKey].Periods.push({Start: i.Start, End: i.End})
      }
    })

    let groupArray = Object.keys(groups).map(x => groups[x])

    return (
      <div className='carrental-assignment'>
        {groupArray.map(this.renderGroup)}
      </div>
    )
  }
}

CarRentalAssignmentList.defaultProps = {
  items: []
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(CarRentalAssignmentList)



// WEBPACK FOOTER //
// ./src/app/shared/components/CarRentalAssignmentList/index.js